/**
 * This is the list of variants and the token that corresponds to the variant
 * @param theme
 */
export const buildVariantMap = theme => {
  const tokenMap = {
    h1: {
      tag: 'h1',
      token: theme.tokens.SemTypographyHeadingH1
    },
    h2: {
      tag: 'h2',
      token: theme.tokens.SemTypographyHeadingH2
    },
    h3: {
      tag: 'h3',
      token: theme.tokens.SemTypographyHeadingH3
    },
    h4: {
      tag: 'h4',
      token: theme.tokens.SemTypographyHeadingH4
    },
    h5: {
      tag: 'h5',
      token: theme.tokens.SemTypographyHeadingH5
    },
    h6: {
      tag: 'h6',
      token: theme.tokens.SemTypographyHeadingH6
    },
    'body-lg': {
      tag: 'div',
      token: theme.tokens.SemTypographyBodyLg
    },
    'body-md': {
      tag: 'div',
      token: theme.tokens.SemTypographyBodyMd
    },
    'body-sm': {
      tag: 'div',
      token: theme.tokens.SemTypographyBodySm
    },
    'body-xs': {
      tag: 'div',
      token: theme.tokens.SemTypographyBodyXs
    },
    'body-xxs': {
      tag: 'div',
      token: theme.tokens.SemTypographyBodyXxs
    },
    'strong-lg': {
      tag: 'strong',
      token: theme.tokens.SemTypographyStrongLg
    },
    'strong-md': {
      tag: 'strong',
      token: theme.tokens.SemTypographyStrongMd
    },
    'strong-sm': {
      tag: 'strong',
      token: theme.tokens.SemTypographyStrongSm
    },
    'strong-xs': {
      tag: 'strong',
      token: theme.tokens.SemTypographyStrongXs
    },
    'strong-xxs': {
      tag: 'strong',
      token: theme.tokens.SemTypographyStrongXxs
    },
    'anchor-block-lg': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorBlockLg
    },
    'anchor-block-md': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorBlockMd
    },
    'anchor-block-sm': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorBlockSm
    },
    'anchor-block-xs': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorBlockXs
    },
    'anchor-block-xxs': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorBlockXxs
    },
    'anchor-inline-lg': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorInlineLg
    },
    'anchor-inline-md': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorInlineMd
    },
    'anchor-inline-sm': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorInlineSm
    },
    'anchor-inline-xs': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorInlineXs
    },
    'anchor-inline-xxs': {
      tag: 'a',
      token: theme.tokens.SemTypographyAnchorInlineXxs
    },
    'list-lg': {
      tag: 'li',
      token: theme.tokens.SemTypographyListLg
    },
    'list-md': {
      tag: 'li',
      token: theme.tokens.SemTypographyListMd
    },
    'list-sm': {
      tag: 'li',
      token: theme.tokens.SemTypographyListSm
    },
    'list-xs': {
      tag: 'li',
      token: theme.tokens.SemTypographyListXs
    },
    'list-xxs': {
      tag: 'li',
      token: theme.tokens.SemTypographyListXxs
    },
    'label-lg': {
      tag: 'label',
      token: theme.tokens.SemTypographyLabelLg
    },
    'label-md': {
      tag: 'label',
      token: theme.tokens.SemTypographyLabelMd
    },
    'label-sm': {
      tag: 'label',
      token: theme.tokens.SemTypographyLabelSm
    }
  };
  return tokenMap;
};
export const variantTokenMap = (variant, variantMap) => {
  return variantMap[variant];
};